import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTypography-gutterBottom': {
      margin: theme.spacing(0, 0, 1, 0),
    },
    '& .MuiSvgIcon-root': {
      color: 'rgba(0,0,0,0.54)',
    },
  },
  formControl: {
    paddingTop: theme.spacing(2),
  },
  password: {
    paddingTop: theme.spacing(1),
  },
  button: {
    width: 200,
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
  },
  boldLink: {
    fontWeight: 600,
  },
}));
